type T = (name: string) => string | null;

const f: T = (name) => {
    const cookie = `; ${document.cookie}`;
    const parts = cookie.split(`; ${name}=`);

    const value = parts.length === 2 ? parts.pop()?.split(';').shift() : null;

    return value || null;
};

export default f;
